import { IBranding } from '../user';
import { IOrgContext } from '../organization/organization-model';
export interface IWSContext extends IOrgContext {
    workspaceId: string;
}
export interface IWorkspaceEntityCounts {
    projectCount: number;
    assetCount: number;
    userCount: number;
    templateCount: number;
    createdByEmail: string;
}

interface IBasicWorkspace extends IWorkspaceEntityCounts {
    id: string;
    name: string;
    branding: IBranding;
    isMaster: boolean;
}

export interface IWorkspaceMetadata extends IBasicWorkspace {
    isDefaultForUser: boolean;
}

export interface IWSInDTO extends IBasicWorkspace {}

export interface IWorkspace extends IBasicWorkspace {
    isWsOwner: boolean;
}

export enum WSUpdateAssocEnum {
    USER = 'user',
    PROJECT = 'project',
    ASSET = 'asset',
    TEMPLATE = 'template',
}
export type WSUpdateAction = 'nameUpdated';
export type WSAssocUpdateActionType = 'removeAssoc' | 'addAssoc' | 'updateAssoc';
